<template>
  <article class="flex flex-col">
    <h1
      class="mb-[24px] text-center font-roboto text-[32px] font-medium leading-6 text-specialprojectsection"
    >
      Видеолекции
    </h1>
    <CommonComplexFiltering
      v-if="false"
      :key="isAnyFiltersActive"
      class="mb-[20px]"
      is-centuries-disabled
      :rubrics-list="rubrics?.data?.value"
      :sort-options="sortOptions"
      :filters-active="filters"
    />
    <!-- :sources-list="sources?.data?.value" -->
    <div class="-m-2.5 flex flex-wrap">
      <MainPageCardsReworkedVideoCard
        v-for="lecture in lectures?.data?.value?.data"
        :key="lecture.id"
        class="w-full max-w-[100%] p-2.5 sm:max-w-[50%] xl:max-w-[33.33333%]"
        :data="lecture"
        @open:video="handleOpenVideo(lecture)"
      />
    </div>

    <BaseThePagination :entity="lectures" />

    <!-- <div class="mt-[64px] flex justify-center">
      <BaseTheButtonNew
        v-if="lectures.hasNextPage.value"
        text="Показать еще"
        @click="lectures.fetchNextPage()"
      />
    </div> -->
  </article>
</template>

<script setup>
import { Fancybox } from 'fancyapps-ui';

const route = useRoute();
const router = useRouter();

const filters = computed(() => {
  return {
    sort_by: route.query?.sort_by,
    category: route.query?.category,
    source: route.query?.source,
  };
});

const page = computed(() => Number(route.query?.page) || 1);
// const { sources } = useSources({ main: true });
const { lectures, resetPage } = useVideoLectures({
  filters,
  per_page: 9,
  page,
});
const { rubrics } = useVideoLecturesCategories();

watch(filters, (newValue, prevValue) => {
  if (JSON.stringify(newValue) === JSON.stringify(prevValue)) return;
  router.push({ query: { ...route.query, page: undefined } });
  resetPage(prevValue);
});

const isAnyFiltersActive = computed(() => Object.values(route.query).length);

const handleOpenVideo = (item) => {
  new Fancybox([
    {
      src: item.video_code,
      caption: item.title,
      type: 'iframe',
      preload: false,
      Html: {
        autoSize: false,
      },
      customClass: 'my-iframe',
    },
  ]);
};

const sortOptions = [
  { id: 0, label: 'Свежие', value: '', icon: 'timer' },
  { id: 1, label: 'Популярные', value: 'views', icon: 'eye' },
  { id: 2, label: 'Любимые', value: 'likes', icon: 'like' },
];

const { canonicalUrl, title } = useSeoHelper();

useHead(() => ({
  title: title(
    'Видеолекции по истории РФ для школьников и студентов | Смотреть на Федеральном портале Истории России',
  ),
  meta: [
    {
      hid: 'description',
      name: 'description',
      content:
        'Видеолекции истории России от выдающихся профессоров и историков нашей страны. Российское военно-историческое общество. Мы знаем правду.',
    },
  ],
  link: [
    {
      rel: 'canonical',
      href: canonicalUrl.value,
    },
  ],
}));
</script>
